module.exports = __webpack_public_path__ + "img/234.toilet_service.1a918936.svg";